// extracted by mini-css-extract-plugin
module.exports = {"comingSoon":"ComingSoonPage_comingSoon__2EgK0","comingSoonButton":"ComingSoonPage_comingSoonButton__nZNo_"};